import { render } from "./ApplyToMoreProducts.vue?vue&type=template&id=519d5674&scoped=true"
import script from "./ApplyToMoreProducts.vue?vue&type=script&lang=js"
export * from "./ApplyToMoreProducts.vue?vue&type=script&lang=js"

import "./ApplyToMoreProducts.vue?vue&type=style&index=0&id=519d5674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519d5674"]])

export default __exports__